<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 13.165 17.761">
        <g id="dropper" transform="translate(-0.017 0)">
            <path id="Path_69772" data-name="Path 69772"
                  d="M44.33,11.591a.932.932,0,0,0,.661-.273l.42-.42a.935.935,0,0,0,1.232-.078l3.8-3.8.427.427a.285.285,0,0,0,.4,0L52.4,6.324a.285.285,0,0,0,0-.4l-.264-.263,2.309-2.309A1.963,1.963,0,0,0,51.666.572L49.357,2.88l-.264-.264a.285.285,0,0,0-.4,0L47.563,3.744a.285.285,0,0,0,0,.4l.427.428-3.8,3.8a.935.935,0,0,0-.1,1.2L43.67,10a.934.934,0,0,0,.66,1.594ZM52.069.975a1.393,1.393,0,1,1,1.969,1.969L51.73,5.253,49.761,3.284ZM48.892,3.222l2.9,2.9-.724.724-.394-.394a.283.283,0,0,0-.071-.07L48.633,4.411a.285.285,0,0,0-.071-.071l-.394-.394ZM44.073,10.4l.616-.616a.285.285,0,0,0,0-.4L44.6,9.289a.364.364,0,0,1,0-.514l3.8-3.8L50.035,6.62l-3.8,3.8a.364.364,0,0,1-.514,0l-.118-.118a.285.285,0,0,0-.4,0l-.616.616a.364.364,0,1,1-.514-.514Zm0,0"
                  transform="translate(-41.832 0)" fill="#799cfb"/>
            <path id="Path_69773" data-name="Path 69773"
                  d="M2.308,339.822a2.316,2.316,0,0,0,2-1.167,2.063,2.063,0,0,0,.009-2.09l-.014-.022L2.54,334.087a.282.282,0,0,0-.232-.116h0a.282.282,0,0,0-.232.115L.311,336.538c-.005.007-.01.014-.015.022a2.073,2.073,0,0,0,.011,2.1,2.316,2.316,0,0,0,2,1.164ZM.783,336.858l1.525-2.119,1.525,2.125a1.479,1.479,0,0,1-.018,1.507,1.729,1.729,0,0,1-3.012,0,1.489,1.489,0,0,1-.02-1.515Zm0,0"
                  transform="translate(0 -322.061)" fill="#799cfb"/>
            <path id="Path_69774" data-name="Path 69774"
                  d="M56.16,428.054a1.355,1.355,0,0,0,1.356-1.351.285.285,0,1,0-.571,0,.784.784,0,0,1-.786.78.285.285,0,0,0,0,.571Zm0,0"
                  transform="translate(-53.866 -411.211)" fill="#799cfb"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "ITestNoBg",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
